import React, { useRef, useState, useEffect } from 'react';
import { Printer, Edit2, Save, X, Trash2, Plus, Upload  } from 'lucide-react';
import apiService from "../../config";
import AddFinalLandholdingList from "../DRO/AddFinalLandholdingList";
import { useSignature } from '../../DigitalSignature/UseSignatue';
import SignaturePad from '../../DigitalSignature/SignaturePad';

const FinalLandAllotmentList = (onBack) => {
  const documentRef = useRef(null);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [projectId, setProjectId] = useState(null);
  const [proposalId, setProposalId] = useState(null);
  const [locationInfo, setLocationInfo] = useState({
    district: '',
    taluka: '',
    village: ''
  });
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState({
    classification: "",
    shera: ""
  });
  const [showAddForm, setShowAddForm] = useState(false);
  const [fullName, setFullName] = useState('');
  const [designation , setDesignation] =useState('');
   const [showSignaturePad, setShowSignaturePad] = useState(false);
    const [pdfForSigning, setPdfForSigning] = useState(null);
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const [viewerFile, setViewerFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const {
      uploadStatus,
      uploadError,
      selectedSignDocument,
      resetSignatureState,
      setUploadStatus,
      setUploadError,
      signDocument
    } = useSignature();

   useEffect(() => {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      setFullName(userData.full_name || '');
      setDesignation(userData.designation || '');
    }, []);


  // Get projectId & proposalId
  useEffect(() => {
    const getProjectId = () => {
      const currentProjectData = localStorage.getItem('currentProjectData');
      if (currentProjectData) {
        const p = JSON.parse(currentProjectData);
        return p.project_id || p.id;
      }

      const selectedProject = localStorage.getItem('selectedProject');
      if (selectedProject) {
        const p = JSON.parse(selectedProject);
        return p.project_id || p.id;
      }

      const userData = localStorage.getItem('userData');
      if (userData) {
        const u = JSON.parse(userData);
        return u?.data?.project_id || u?.project_id || null;
      }
      return null;
    };

    const getProposalId = () => {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      return (
        userData?.data?.default_proposal ||
        userData?.data?.proposal_id ||
        userData?.default_proposal ||
        userData?.proposal_id ||
        null
      );
    };

    setProjectId(getProjectId());
    setProposalId(getProposalId());
  }, []);

  // Fetch & map data
  useEffect(() => {
    const fetchFinalAllotmentData = async () => {
      if (!projectId || !proposalId) return;

      try {
        setLoading(true);
        const response = await apiService.getFamilyDetails(projectId, proposalId);

        let rawData = [];
        if (Array.isArray(response?.data)) rawData = response.data;
        else if (Array.isArray(response?.data?.data)) rawData = response.data.data;
        else if (Array.isArray(response)) rawData = response;

        const mappedData = rawData.map((item, index) => ({
          id: item.land_owner_id,
          serial: index + 1,
          name: item.owner_name || 'N/A',
          members: item.familyDetails?.length || 1,
          plot: 
            item.allotted_plot_no ||
            item.plot_number ||
            item.final_plot ||
            item.LandAcquisition_id ||
            '-',
          survey_no:item.survey_no,
          shera: item.Family_antim_report_remarks || '',
          classification: item.Family_11_1_classification || 'खातेदार' // fallback
        }));

        if (rawData.length > 0) {
          setLocationInfo({
            district: rawData[0].dist_name || '',
            taluka: rawData[0].taluka_name || '',
            village: rawData[0].village_name || ''
          });
        }

        setTableData(mappedData);
      } catch (error) {
        console.error('Error fetching final allotment data:', error);
        setTableData([]);
      } finally {
        setLoading(false);
      }
    };

    if (projectId && proposalId) {
      fetchFinalAllotmentData();
    }
  }, [projectId, proposalId]);

  const startEdit = (row) => {
  setEditingId(row.id);
  setEditData({
    classification: row.classification,
    shera: row.shera
  });
};

const cancelEdit = () => {
  setEditingId(null);
  setEditData({ classification: "", shera: "" });
};

const saveEdit = async (row) => {
  try {
    await apiService.patchUpdateMeasurement(row.id, {
      // Family_11_1_classification: editData.classification,
      Family_antim_report_remarks: editData.shera
    });

    setTableData(prev =>
      prev.map(item =>
        item.id === row.id
          ? { ...item, ...editData }
          : item
      )
    );

    setEditingId(null);
    alert("✅ माहिती अपडेट झाली");
  } catch (err) {
    console.error(err);
    alert("❌ अपडेट अयशस्वी");
  }
};

const handleAddCancel = () => {
        setShowAddForm(false);
    };

const handleAddNew = () => {
  if (!projectId || !proposalId) {
    alert("Project ID or Proposal ID missing");
    return;
  }

  const info = {
    projectId,
    proposalId,
    district: locationInfo.district || "",
    taluka: locationInfo.taluka || "",
    village: locationInfo.village || ""
  };

  // SAME localStorage key (IMPORTANT)
  localStorage.setItem("selectedLocationInfo", JSON.stringify(info));

  setShowAddForm(true);
};


const deleteRow = async (row) => {
  if (!window.confirm("ही नोंद हटवायची आहे का?")) return;

  try {
    await apiService.deleteLandHolding(row.id); // 🔴 backend delete API

    setTableData(prev =>
      prev.filter(item => item.id !== row.id)
    );

    alert("✅ नोंद हटवली");
  } catch (err) {
    console.error(err);
    alert("❌ Delete अयशस्वी");
  }
};

const handleUploadedFile = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  resetSignatureState();     // 🔥 important
  setPdfForSigning(file);
  setShowSignaturePad(true);
};

 useEffect(() => {
  if (!selectedSignDocument) return;

  const postSignedPdf = async () => {
    try {
      const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
      const projectId = selectedProject?.id || selectedProject?.project_id;
      const proposalId = localStorage.getItem("currentProposalId");

      if (!projectId || !proposalId) {
        console.error("Missing projectId or proposalId");
        return;
      }

      await apiService.postAddSignaturePDF(
        projectId,
        proposalId,
        "Finallist",      // 🔁 change per section
        selectedSignDocument   // ✅ signed PDF only
      );

      const sectionRes = await apiService.getSectionFile(
        projectId,
        proposalId,
        "Finallist"
      );

      if (sectionRes?.isSignAvailable && sectionRes.data?.[0]?.file_path) {
        setPreviewUrl(sectionRes.data[0].file_path);
      }

    } catch (error) {
      console.error("Error posting signed PDF:", error);
    }
  };

  postSignedPdf();
}, [selectedSignDocument]);

const handleViewSignedPdf = async () => {
  try {
    const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
    const projectId = selectedProject?.id || selectedProject?.project_id;
    const proposalId = localStorage.getItem("currentProposalId");

    if (!projectId || !proposalId) {
      alert("Project or Proposal not found");
      return;
    }

    const res = await apiService.getSectionFile(
      projectId,
      proposalId,
      "Finallist" 
    );

    if (res?.isSignAvailable && res?.data?.[0]?.file_path) {
      setViewerFile(res.data[0].file_path);
      setIsViewerOpen(true);     // modal
      // OR 👉 window.open(res.data[0].file_path, "_blank");
    } else {
      alert("Signed document not available");
    }
  } catch (error) {
    console.error("Error viewing signed PDF:", error);
    alert("Unable to open signed document");
  }
};

const SignatureLoader = ({ text }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
    <div className="bg-white rounded-lg p-6 flex flex-col items-center space-y-4">
      <div className="animate-spin rounded-full h-10 w-10 border-4 border-blue-600 border-t-transparent"></div>
      <p className="text-sm font-medium text-gray-700">{text}</p>
    </div>
  </div>
);


  // Group data by classification and member count
  const khatedar = tableData.filter(item => item.classification === "खातेदार");
  const vigarKhatedar = tableData.filter(item => item.classification === "विगर खातेदार");

  const getGroups = (data) => ({
    "1-5": data.filter(r => r.members >= 1 && r.members <= 5),
    "6-8": data.filter(r => r.members >= 6 && r.members <= 8),
    "9+": data.filter(r => r.members >= 9)
  });

  const khatedarGroups = getGroups(khatedar);
  const vigarGroups = getGroups(vigarKhatedar);

  const renderSection = (title, groups, areas) => (
    <>
      <div className="text-center font-bold mt-10 mb-4" style={{ fontSize: '17px' }}>
        {title}
      </div>

      {[
        { key: "1-5", label: "1 ते 5", area: areas[0] },
        { key: "6-8", label: "6 ते 8", area: areas[1] },
        { key: "9+", label: "9 ते वरील", area: areas[2] }
      ].map(({ key, label, area }) => {
        const groupData = groups[key];
        if (groupData.length === 0) return null;

        return (
          <div key={key} style={{ marginBottom: '40px' }}>
            <div className="text-center font-bold mb-3" style={{ fontSize: '15px' }}>
              कुटुंब सदस्य संख्या {label} देय क्षेत्रफळ {area} चौरस मिटर
            </div>

            <table className="w-full border-2 border-black">
              <thead>
                <tr className="font-bold">
                  <th className="border border-black p-2" style={{ width: '60px' }}>अ.क्र.</th>
                  <th className="border border-black p-2">प्रकल्पग्रस्ताचे नाव</th>
                  <th className="border border-black p-2" style={{ width: '100px' }}>सदस्य<br/>संख्या</th>
                  <th className="border border-black p-2" style={{ width: '100px' }}>भूखंड<br/>क्रमांक</th>
                  <th className="border border-black p-2" style={{ width: '120px' }}>शेरा</th>
                  <th className="border border-black p-2 noprint" style={{ width: "120px" }}>क्रिया</th>

                </tr>
              </thead>
              <tbody>
                <tr className="text-center font-bold">
                  <td className="border border-black p-2">1</td>
                  <td className="border border-black p-2">2</td>
                  <td className="border border-black p-2">3</td>
                  <td className="border border-black p-2">4</td>
                  <td className="border border-black p-2">5</td>
                  <td className="border border-black p-2 noprint">6</td>
                </tr>

                {groupData.map((row , index) => (
                  <tr key={row.id}>
                    <td className="border border-black p-2 text-center">{index + 1}</td>
                    <td className="border border-black p-2 text-left">{row.name}</td>
                    <td className="border border-black p-2 text-center">{row.members}</td>
                    <td className="border border-black p-2 text-center">{row.survey_no}</td>
                    {/* <td className="border border-black p-2">{row.shera || '-'}</td> */}
                    <td className="border border-black p-2">
                    {editingId === row.id ? (
                      <textarea
                        value={editData.shera}
                        onChange={(e) =>
                          setEditData(prev => ({ ...prev, shera: e.target.value }))
                        }
                        className="border p-1 w-full"
                        rows={2}
                      />
                    ) : row.shera}
                  </td>
                    <td className="border border-black p-2 text-center noprint">
                    {editingId === row.id ? (
                      <div className="flex gap-2 justify-center">
                        <button
                          onClick={() => saveEdit(row)}
                          className="bg-green-500 text-white p-1 rounded"
                        >
                          <Save size={16} />
                        </button>
                        <button
                          onClick={cancelEdit}
                          className="bg-red-500 text-white p-1 rounded"
                        >
                          <X size={16} />
                        </button>
                      </div>
                    ) : (
                      <div className="flex gap-2 justify-center">
                        <button
                          onClick={() => startEdit(row)}
                          className="bg-blue-500 text-white p-1 rounded"
                        >
                          <Edit2 size={16} />
                        </button>
                        <button
                          onClick={() => deleteRow(row)}
                          className="bg-red-600 text-white p-1 rounded"
                        >
                          <Trash2 size={16} />
                        </button>
                      </div>
                    )}
                  </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })}
    </>
  );

  const handlePrint = () => {
    const printContent = documentRef.current?.innerHTML;
    if (!printContent) {
      alert("No content available to print.");
      return;
    }

    const win = window.open("", "", "height=900,width=1200");
    win.document.write(`
      <html>
        <head>
          <title>भूखंड वाटपाची अंतिम यादी</title>
          <style>
            @page {
              size: A4 portrait;
              margin: 0.5in 0.4in;
            }
            body {
              font-family: 'Noto Sans Devanagari', 'Mangal', 'Arial', sans-serif;
              font-size: 15px;
              line-height: 1.4;
              color: #000;
              margin: 0;
              padding: 0;
            }
            .text-center { text-align: center; }
            .font-bold { font-weight: bold; }
            table {
              width: 100%;
              border-collapse: collapse;
              border: 2px solid #000;
              page-break-inside: avoid;
              margin-bottom: 25px;
            }
            th, td {
              border: 1px solid #000;
              padding: 6px 8px;
              text-align: center;
              vertical-align: middle;
            }
            th { font-weight: bold; }
            button {
            display: none
            }

            .signature{
            text-align : right
            }

            .noprint{
            display: none
            }
          </style>
        </head>
        <body>
          ${printContent}
        </body>
      </html>
    `);
    win.document.close();
    win.print();
  };

  if (loading) {
    return (
      <div className="p-6 text-center font-bold text-xl">
        अंतिम भूखंड वाटप यादी लोड होत आहे...
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="flex justify-start mb-6">
        <button
          onClick={handleAddNew}
          className="px-5 py-3 mr-4 text-sm rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg font-medium group bg-gradient-to-r from-blue-600 to-gray-900 hover:from-blue-700 hover:to-blue-800 text-white"
        >
          <Plus className="h-5 w-5 group-hover:rotate-90 transition-transform duration-300" />
          <span>Add Landholding</span>
        </button>

        {/* <button className="relative">
                  <label className="flex items-center space-x-2 px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 cursor-pointer">
                    <Upload size={18} />
                    <span>Upload Signature</span>
                    <input
                      type="file"
                      accept="application/pdf,image/*"
                      className="hidden"
                      onChange={handleUploadedFile}
                    />
                  </label>
                </button>
      
                <button
                onClick={handleViewSignedPdf}
                className="flex items-center mx-3 space-x-2 px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700"
              >
                <Printer size={18} />
                <span>View Signed PDF</span>
              </button> */}

        <button
          onClick={handlePrint}
          className="flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors shadow-lg"
        >
          <Printer size={20} />
          Print
        </button>
      </div>

      {showAddForm && (
  <div className="mt-6">
    <AddFinalLandholdingList
      onBack={handleAddCancel}
      onSuccess={() => {
        setShowAddForm(false);
        window.location.reload(); // OR refetch API
      }}
      onCancel={() => setShowAddForm(false)}
    />
  </div>
)}

      <div
        ref={documentRef}
        className="bg-white shadow-2xl rounded-lg overflow-hidden p-8"
        style={{
          fontFamily: "'Noto Sans Devanagari', 'Mangal', Arial, sans-serif",
          fontSize: "15px",
          lineHeight: "1.5"
        }}
      >
        {/* Header */}
        <div className="text-center font-bold mb-2" style={{ fontSize: '15px' }}>
          जिगांव प्रकल्प {locationInfo.taluka || 'नांदुरा'} जिल्हा {locationInfo.district || 'बुलढाणा'}
        </div>
        <div className="text-center mb-2" style={{ fontSize: '15px' }}>
          मौजे {locationInfo.village} तालुका {locationInfo.taluka || 'नांदुरा'} जिल्हा {locationInfo.district || 'बुलढाणा'} येथील प्रकल्पग्रस्ताचे कुटुंब
        </div>
        <div className="text-center mb-2" style={{ fontSize: '15px' }}>
          सदरक्षण आणि घराचा अतिरिक्त निवाडानुसार तयार करण्यात आलेली प्रकल्पग्रस्तानी
        </div>
        <div className="text-center font-bold mb-4" style={{ fontSize: '16px' }}>
          भूखंड वाटपाची अंतिम यादी (नवीन गावठाण पलशीघाट)
        </div>

        {/* Khatedar Section */}
        {khatedar.length > 0 && renderSection(
          "खातेदार",
          khatedarGroups,
          ["370.00", "555.00", "740.00"]
        )}

        {/* Vigar Khatedar Section */}
        {vigarKhatedar.length > 0 && renderSection(
          "विगर खातेदार",
          vigarGroups,
          ["185.00", "277.00", "370.00"]
        )}

        {tableData.length === 0 && (
          <div className="text-center mt-8 text-gray-600">
            यादी उपलब्ध नाही
          </div>
        )}

        <div className="mt-10 text-right signature">
          <div className="font-bold">{fullName}</div>
          <div>{designation}</div>
        </div>
      </div>
      
      {showSignaturePad && pdfForSigning && (
  <SignaturePad
    pdfFile={pdfForSigning}
    onSign={(signaturesArray) => {
      setShowSignaturePad(false);

      // ✅ ONLY sign here
      signDocument(pdfForSigning, signaturesArray);

      setPdfForSigning(null);
    }}
    onCancel={() => {
      setShowSignaturePad(false);
      setPdfForSigning(null);
    }}
  />
)}

{isViewerOpen && viewerFile && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
    <div className="bg-white rounded-lg w-[80%] max-w-6xl h-[80%] relative">

      <div className="flex justify-between items-center px-4 py-2 border-b">
        <h3 className="text-lg font-semibold">Signed Document</h3>
        <button
          onClick={() => setIsViewerOpen(false)}
          className="text-xl font-bold"
        >
          ✕
        </button>
      </div>

      <iframe
        src={viewerFile}
        title="Signed PDF Viewer"
        className="w-full h-full"
      />
    </div>
  </div>
)}

{(uploadStatus === "signing" || uploadStatus === "uploading") && (
  <SignatureLoader
    text={
      uploadStatus === "signing"
        ? "Applying digital signature…"
        : "Uploading signed document…"
    }
  />
)}

    </div>
  );
};

export default FinalLandAllotmentList;